
import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Contact from './components/Contact';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/a734f118-0d5d-4209-aa73-7f35b3e8a30d.png" 
              alt="JIM d.o.o. Mostar Logo" 
              className="h-10 w-10 object-contain"
            />
            <span className={`text-xl font-bold transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
              JIM d.o.o. Mostar
            </span>
          </div>
          <div className="flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors hover:opacity-80 whitespace-nowrap ${scrolled ? 'text-gray-700' : 'text-white'}`}
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors hover:opacity-80 whitespace-nowrap ${scrolled ? 'text-gray-700' : 'text-white'}`}
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('products')}
              className={`text-sm font-medium transition-colors hover:opacity-80 whitespace-nowrap ${scrolled ? 'text-gray-700' : 'text-white'}`}
            >
              Products
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors hover:opacity-80 whitespace-nowrap ${scrolled ? 'text-gray-700' : 'text-white'}`}
            >
              Contact
            </button>
          </div>
        </div>
      </nav>

      {/* Sections */}
      <Hero />
      <About />
      <Products />
      <Contact />
    </div>
  );
}